import { forwardRef, memo } from "react";

export const BalanceIcon = memo(
  forwardRef(function BalanceIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M24.0235 14.2911H23.6558L21.9799 8.69142H24.2676C24.6721 8.69142 25 8.36349 25 7.959C25 7.55451 24.6721 7.22658 24.2676 7.22658H13.2324V4.26856C14.0849 3.96622 14.6972 3.15211 14.6972 2.19727C14.6972 0.985695 13.7116 0 12.5 0C11.2884 0 10.3027 0.985695 10.3027 2.19727C10.3027 3.15211 10.9151 3.96622 11.7676 4.26856V7.22658H0.732423C0.32793 7.22658 0 7.55451 0 7.959C0 8.36349 0.32793 8.69142 0.732423 8.69142H3.02017L1.34429 14.2911H0.976564C0.438087 14.2911 0 14.7292 0 15.2677C0 17.2421 1.6063 18.8484 3.58072 18.8484H4.42706C6.40148 18.8484 8.00778 17.2421 8.00778 15.2677C8.00778 14.7292 7.56969 14.2911 7.03121 14.2911H6.66349L4.98761 8.69142H11.7676V20.6055H9.39938C8.45705 20.6055 7.6904 21.3722 7.6904 22.3145V23.7793C7.6904 24.4524 8.238 25 8.9111 25H16.0889C16.7619 25 17.3096 24.4524 17.3096 23.7793V22.3145C17.3096 21.3722 16.5429 20.6055 15.6006 20.6055H13.2324V8.69142H20.0124L18.3365 14.2911H17.9688C17.4303 14.2911 16.9922 14.7292 16.9922 15.2677C16.9922 17.2421 18.5985 18.8484 20.5729 18.8484H21.4193C23.3937 18.8484 25 17.2421 25 15.2677C25 14.7292 24.562 14.2911 24.0235 14.2911ZM12.5 1.46485C12.9038 1.46485 13.2324 1.79341 13.2324 2.19727C13.2324 2.60113 12.9038 2.92969 12.5 2.92969C12.0961 2.92969 11.7676 2.60113 11.7676 2.19727C11.7676 1.79341 12.0961 1.46485 12.5 1.46485ZM4.42706 17.3836H3.58072C2.58199 17.3836 1.74268 16.6881 1.52168 15.756H6.4861C6.2651 16.6881 5.42579 17.3836 4.42706 17.3836ZM2.8733 14.2911L4.00391 10.5135L5.13453 14.2911H2.8733ZM15.8447 22.3145V23.5352H9.15524V22.3145C9.15524 22.1799 9.26476 22.0704 9.39938 22.0704H15.6006C15.7352 22.0704 15.8447 22.1799 15.8447 22.3145ZM20.9961 10.5135L22.1268 14.2911H19.8656L20.9961 10.5135ZM21.4193 17.3836H20.573C19.5743 17.3836 18.735 16.6881 18.514 15.756H18.8819H23.1105H23.4784C23.2574 16.6881 22.418 17.3836 21.4193 17.3836Z"
          fill={color}
        />
      </svg>
    );
  }),
);

BalanceIcon.displayName = "BalanceIcon";